module.exports = __webpack_public_path__ + "img/haiwai1.dc7acabf.png";